import { accountService } from "../../../_services/account.service"

const Logout = () => {
    accountService.logOut();
    window.location.href='/';
};

export default Logout;